import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { CreateAssessmentComponent } from "./create-assessment/create-assessment.component";
import { ListAssessmentComponent } from "./list-assessment/list-assessment.component";
import { Routes, RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";
import { AssessmentDetailsComponent } from "./assessment-details/assessment-details.component";
import { PublishComponent } from "./publish-link/publish.component";
import { AssessmentTypeComponent } from "./assessment-type/assessment-type.component";
import { ListAssignedBatchesComponent } from "./list-assigned-batches/list-assigned-batches.component";
import { ListAssignedBatchCandidatesComponent } from "./list-assigned-batch-candidates/list-assigned-batch-candidates.component";
import { ListOfCandidatesComponent } from "./list-of-candidates/list-of-candidates.component";
import { JobService } from "../jobs/jobs.service";
import { QuickAssessmentPopupComponent } from "./quick-assessment-popup/quick-assessment-popup.component";
import { CreateQuickAssessmentComponent } from "./create-quick-assessment/create-quick-assessment.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalModule } from "ngx-bootstrap/modal";
import { HeaderComponent } from "../../app/header/header.component";
import { EvaluatorComponent } from "./evaluator/evaluator.component";
import { EvaluateAssessmentComponent } from "./evaluate-assessment/evaluate-assessment.component";
import { BatchEvaluatorComponent } from "./batch-evaluator/batch-evaluator.component";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { AssignEvaluatorComponent } from './assign-evaluator/assign-evaluator.component';

const routes: Routes = [
  { path: "", redirectTo: "list", pathMatch: "full" },
  { path: "list", component: AssessmentTypeComponent },
  { path: "list/:type", component: ListAssessmentComponent },
  { path: "create/:type", component: CreateAssessmentComponent },
  { path: "create", component: CreateAssessmentComponent },
  {
    path: "create-from-template/:id",
    component: CreateQuickAssessmentComponent,
  },
  {
    path: "update-quick-assessment/:id",
    component: CreateQuickAssessmentComponent,
  },

  { path: "update/:id", component: CreateAssessmentComponent },
  { path: "publish-link/:id", component: PublishComponent },
  { path: "editlink/:editId", component: PublishComponent },
  { path: "details/:id", component: AssessmentDetailsComponent },
  { path: "assigned-batches/:role", component: ListAssignedBatchesComponent },
  {
    path: "batch-candidates/:linkId",
    component: ListAssignedBatchCandidatesComponent,
  },
  {
    path: "candidates-assessment/:id",
    component: EvaluateAssessmentComponent,
  },
];
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    RouterModule.forChild(routes),
    AngularEditorModule,
    ModalModule.forRoot(),
    HeaderComponent,
  ],
  declarations: [
    AssessmentTypeComponent,
    CreateAssessmentComponent,
    ListAssessmentComponent,
    AssessmentDetailsComponent,
    PublishComponent,
    ListAssignedBatchesComponent,
    ListAssignedBatchCandidatesComponent,
    ListOfCandidatesComponent,
    QuickAssessmentPopupComponent,
    CreateQuickAssessmentComponent,
    EvaluatorComponent,
    EvaluateAssessmentComponent,
    BatchEvaluatorComponent,
    AssignEvaluatorComponent,
  ],
  providers: [JobService],
  exports: [RouterModule],
})
export class AssessmentsModule {}
